module.exports = __webpack_public_path__ + "static/media/recyclebin.0ac18493.svg";